import React, { useEffect } from "react";
import { connect } from "react-redux";

import { Activity, EntityTypesSupportingRoutes } from "@mapmycustomers/shared/types/entity";

import { smartPlannerViewAnalytics } from "@app/scene/activity/activityTableAnalytics";
import { RootState } from "@app/store/rootReducer";

import { getEntityType, getInvalidStops, getStops } from "../../store";
import StepProps from "../../type/StepProps";
import Step from "../Step";

import styles from "./Adjust.module.scss";
import AdjustFooter from "./AdjustFooter";
import InvalidStops from "./InvalidStops";
import Stops from "./Stops";

interface Props extends StepProps {
  entityType: EntityTypesSupportingRoutes;
  invalidStops: Activity[];
  stops: Activity[];
}

const Adjust: React.FC<Props> = ({ entityType, invalidStops, onBack, onNext, stops }) => {
  useEffect(() => {
    smartPlannerViewAnalytics?.using(["Build routes from activities", "Open step"], {
      stepName: "Adjust stops",
    });
  }, []);

  return (
    <Step
      contentClassName={styles.container}
      footer={
        <AdjustFooter
          entityType={entityType}
          hasInvalidStops={invalidStops.length > 0}
          onBack={onBack}
          onNext={onNext}
          stopsCount={stops.length}
        />
      }
    >
      <InvalidStops />
      <Stops />
    </Step>
  );
};

const mapStateToProps = (state: RootState) => ({
  entityType: getEntityType(state),
  invalidStops: getInvalidStops(state),
  stops: getStops(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Adjust);
